export const FETCH_DEALS_PAGE = "fetchDealsPage";
